import { csx } from '@vtex/admin-ui'

export const menuButton = csx({
  flexDirection: 'row',
  'svg:first-of-type': {
    display: 'none',
  },
})

export const menuActions = csx({
  left: '45px',
})
